
// src/pages/workOrder/WorkOrderNotes.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import Layout from "../../components/layout";
import Notes from "./notes"; // reuse existing Notes component
import { Card, Button } from "antd";

const WorkOrderNotes = () => {
  const { tranId } = useParams();
  const navigate = useNavigate();
  const cookies = new Cookies();
  const token = cookies.get("token");

  const [validTranId, setValidTranId] = useState(false);

  useEffect(() => {
    setValidTranId(Boolean(tranId && tranId !== "null" && tranId !== "undefined"));
  }, [tranId]);

  if (!validTranId) {
    return (
      <Layout sidebarContent={null}>
        <div className="contentclss" style={{ padding: 8 }}>
          <Card>
            <h2>Work order notes</h2>
            <p>No work order id provided in the URL.</p>
            <p>
              Use the link format <code>/workorder/&lt;tranId&gt;/notes</code>
            </p>
            <div style={{ marginTop: 12 }}>
              <Button onClick={() => navigate("/work-order")}>Back to Work Orders</Button>
            </div>
          </Card>
        </div>
      </Layout>
    );
  }

  return (
    <Layout sidebarContent={null}>
      <div className="contentclss" style={{ padding: 24 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 16,
          }}
        >
          <h1>Order #{tranId} — Notes</h1>

        </div>

        {/* Reuse Notes component */}
        <Notes tranId={tranId} isRefresh={{ isRefresh: false, tranId: "" }} hideTaskNotes={true} />
      </div>
    </Layout>
  );
};

export default WorkOrderNotes;

